<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{$t('Company')}}</h6>
                                <h1 class="header-title">{{$t('Tags')}}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:modalName, model:tagDefaults})"
                                    class="btn btn-primary"
                                >{{$t('Add')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Card -->
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>

                    <simple-table :data="tags" :loading="areTagsLoading" :edit="edit" :columns="columns" :sort="sort"></simple-table>
                    <tag-form-modal :data="model" :errors="errors" :saveAction="saveTag" :id="modalName"></tag-form-modal>
                </div>
                <div class="mt-3 text-center" v-if="totalRows > perPage">
                    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SimpleTable from '@/components/SimpleTable.vue'
import TagFormModal from './TagFormModal.vue'
import { modalMixins } from '@/mixins/modal.js'
import { mapActions, mapGetters, mapState } from 'vuex';
import debounce from 'lodash/debounce';

export default {
    mixins: [modalMixins],
    components: {
        SimpleTable,
        TagFormModal,

    },
    data() {
        return {
            tagDefaults: {
            },
            date: null,
            modalName: 'TagFormModal',
            query: null,
            params: {},
            treatmentsQuery: [],
            currentPage: 1,
            perPage: 100,
            totalRows: 0,
            sort: 'createdAt',
            order: -1,
            dates: {},
            date_range: null,
            model: {},
            errors: {},
            columns: [
                {
                    label: 'Color',
                    name: 'color',
                    width: '10%',
                    field(row) {
                        if (row.color)
                            return `<span class="badge badge-pill badge-${row.color}">&nbsp;</span>`;
                    }
                },
                {
                    label: 'Tags',
                    name: 'tag',
                },
            ],

        };
    },
    computed: {
        ...mapState('tags', { areTagsLoading: 'isFindPending' }),
        ...mapGetters('tags', {
            findItemsInStore: 'find'
        }),
        tags() {
            let data = this.findItemsInStore(this.params).data;
            return data;
        },
    },
    watch: {
        query: debounce(function (newVal) {
            this.findItems();
        }, 400),
        currentPage: debounce(function (newVal) {
            this.findItems();
        }, 400),
        treatmentsQuery: debounce(function (newVal) {
            this.findItems();
        }, 400),
    },
    created() {
        this.findItems();
    },
    methods: {
        ...mapActions('tags', ['find', 'remove', 'create', 'patch']),

        findItems() {
            let params = {
                query: {
                    $limit: this.perPage,
                    $skip: (this.currentPage - 1) * this.perPage,
                    $sort: {
                        [this.sort]: this.order
                    }
                }
            }

            if (this.query) {
                // params.query.$search = this.query;
                params.query.$or = [
                    { tag: { $regex: this.query, $options: "i" } },

                ];
            }

            this.params = params;
            this.find(params).then(data => {
                this.totalRows = data.total;
            });
        },
        saveTag(data) {
            this.errors = null;
            let promise, successMessage;

            if (this.model._id) {
                promise = this.patch([this.model._id, this.model]);
                successMessage = 'Tag updated';
            } else {
                promise = this.create(this.model);
                successMessage = 'Tag created';
            }
            promise.then(data => {
                this.$root.$emit('bv::hide::modal', this.modalName);
                this.$toasted.global.success({
                    message: successMessage
                });

            }).catch(errors => {
                this.errors = errors.errors;
            })
        },
        edit(item) {
            this.openModal({
                id: this.modalName,
                model: item
            })
        },
    }
}
</script>
